var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8a1 1 0 0 0 .707-.293l7-7a1 1 0 0 0 .196-.293c.014-.03.022-.061.033-.093a1 1 0 0 0 .051-.259c.002-.021.013-.041.013-.062V5c0-1.103-.897-2-2-2M5 5h14v7h-6a1 1 0 0 0-1 1v6H5zm9 12.586V14h3.586z"
})));
export default SvgNote;